import $ from 'jquery';
import React, { Component } from 'react';
import {DamService} from '../../services/dam';
import Composition from './composition.rdpcomposer';
import './subheader-embed.css';
import { ContentSearch } from '../../components';
import RDP_CONFIG from '../../config';
import { getTheme } from '../../utils/getTheme';

export default class SubheaderEmbed extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showDropdown: false
    };
    this.dropdownRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ showDropdown: false });
    }
  }

  toggleDropdown = () => {
    this.setState(prev => ({ showDropdown: !prev.showDropdown }));
  }

  newComposition() {
    window.location = window.location.origin + window.location.pathname + "#/embed/composer";
  }

  newAudiobook() {
    window.location = window.location.origin + window.location.pathname + "#/embed/audiobook";
  }

  newPdf() {
    window.location = window.location.origin + window.location.pathname + "#/embed/pdf-editor";
  }

  blobToFile(theBlob, fileName){
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
  }

  getFile() {
    var composition = {
      "metadata": {
        "title": "Sem título",
        "description": ""
      },
      "interface": {
        "font_family": "Montserrat-Regular"
      },
      "structure": []
    }
    var myBlob = new Blob([JSON.stringify(composition)], {type : "digitalpages/json"});
    return this.blobToFile(myBlob, "composition.rdpcomposer");
  }

  uploadFile() {
    var uid = JSON.parse(window.localStorage.getItem("rdp-composer-active-project")).connectors[0].uid;
    var url = `https://${RDP_CONFIG.domain}/storage/v1.0/upload/connector/uid/${uid}`;
    var _this = this;

    var fd = new FormData();
    var files = this.getFile();
    fd.append('file', files);

    var userData = JSON.parse(window.localStorage.getItem("rdp-composer-user-data"));
    var type = userData.type;
    var accessToken = userData.access_token;

    $.ajax({
      url: url,
      type: "POST",
      data: fd,
      contentType: false,
      processData: false,
      headers: {
        "Authorization": type + " " + accessToken,
        "Project-Key" : RDP_CONFIG.projectKey,
        "Api-Env" : RDP_CONFIG.apiEnv
      },
      xhr: function(){
        var xhr = new window.XMLHttpRequest();
        xhr.upload.addEventListener("progress", function(evt){
          if (evt.lengthComputable) {
            var percentComplete = parseInt((evt.loaded / evt.total) * 100);
          }
        }, false);
        return xhr;
      },
      success: function(response) {
        window.location = window.location.origin + "/#/composer/" + response[0].metadatas.content_uid;
      }
    });
  }
  
  render() {
    return (
      <div className="rdp-composer-subheader-embed" style={{ 
        ...(getTheme() == 'dark' && {
          borderBottom: '1px dashed #cccccc40'
        })
      }}>
        <span className="rdp-composer-subheader-embed-title" style={{ 
        ...(getTheme() == 'dark' && {
          color: '#fff'
        })
      }}>Composições</span>
        <ContentSearch center={true} onSearchSubmit={(term) => this.props.onSearchSubmit(term)} labels={this.props.labels}/>
        <div className="rdp-composer-subheader-embed-actions">
          {this.props.canEditComposition &&
            <div className="rdp-composer-subheader-embed-dropdown-container" ref={this.dropdownRef}>
              <button className="rdp-composer-subheader-embed-new" style={{
                ...(getTheme() == 'dark' && {
                  background: "#673ab7",
                  cursor: "pointer",
                })
              }} onClick={this.toggleDropdown}>
                Novo conteúdo
              </button>
              {this.state.showDropdown && (
                <div className="rdp-composer-subheader-embed-dropdown">
                  <button onClick={() => this.newComposition()}>{this.props.labels.buttons.new_composition}</button>
                  <button onClick={() => this.newPdf()}>Novo conteúdo PDF</button>
                  <button onClick={() => this.newAudiobook()}>{this.props.labels.buttons.new_audiobook}</button>
                </div>
              )}
            </div>
          }
        </div>
      </div>
    );
  }
}
